import locale from 'live/init/global-locale'
import LiveAPI from 'live/lib/api'
import i18n from 'live/services/i18n'
import serviceLocator from 'live/services/service-locator'

import { ChannelsSettingsWrapper } from './ChannelsSettings'
import { ptBR, enUS } from './i18n'
import { CHANNELS_SETTINGS_URL } from './utils/constants'

const localeFiles = { pt_br: ptBR, en_us: enUS }

try {
    i18n.add(localeFiles[locale])
} catch (error) {
    console.log(error)
}

serviceLocator.getService('live-ui:configuration-service').then(() => {
    LiveAPI.Extension.configuration.entries.register({
        group: 'high-frequency-data',
        area: CHANNELS_SETTINGS_URL,
        component: (ChannelsSettingsWrapper as unknown) as any,
        name: i18n('Real Time Channels')
    })
})
